var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("path",{"d":"M31.73,63.06A31.53,31.53,0,1,1,63.46,31.53,31.67,31.67,0,0,1,31.73,63.06ZM31.73,2A29.53,29.53,0,1,0,61.46,31.53,29.67,29.67,0,0,0,31.73,2Z","key":0}),React.createElement("polygon",{"points":"40.51 31.53 26.46 38.51 26.46 24.55 40.51 31.53","key":1}),React.createElement("path",{"d":"M39.15,48.23H24.31a12.88,12.88,0,0,1-12.9-12.82V27.65a12.88,12.88,0,0,1,12.9-12.82H39.15A12.87,12.87,0,0,1,52,27.65v7.76A12.87,12.87,0,0,1,39.15,48.23ZM24.31,16.83a10.87,10.87,0,0,0-10.9,10.82v7.76a10.87,10.87,0,0,0,10.9,10.82H39.15A10.86,10.86,0,0,0,50,35.41V27.65A10.86,10.86,0,0,0,39.15,16.83Z","key":2})])));
}

Youtube.defaultProps = {"viewBox":"0 0 63.46 63.06"};

module.exports = Youtube;

Youtube.default = Youtube;
